$(document).on("turbo:load", () => {
  if( $(".highlighted-comment").length ) {
    $([document.documentElement, document.body]).animate({
      scrollTop: $(".highlighted-comment").offset().top - 80
    }, 1000);
  }
});